// skeleton/app/src/app/logout/logout.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { SiteminderAuthService } from '../auth/oidc-config.service';

import { LogoutServive } from '../logout/logout.service';

import { Constants } from '../shared/constants';
import { KeyValue } from '../shared/models/keyvalue.model';

import { BaseHttpService } from '../shared/services/basehttp.service';
import { UserServiceService } from '../user/survey-main/service/user-service.service';

import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { MenubarService } from '../shared/services/menunavbar.services';
import { AuthorizationService } from '../shared/services/authorization.service';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constants: Constants = new Constants();

  LoginName: string = 'UN';
  UserRole: number = 0;
  UserGroup: string = null;

  isAnonymousResponse: boolean = false;

  routeSurveyId: string;
  groupId: string;

  fullName: string;
  email: string;

  profileEnabled: boolean = false;
  userLoginStatus: boolean = false;
  testFlag: boolean = false;
  userRoleName: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private logoutservice: LogoutServive,
    private baseHttpService: BaseHttpService,
    private userService: UserServiceService,
    private route: ActivatedRoute,
    private sessionHandlerService: GlobalsessionhandlerService,
    private menubarService: MenubarService,
    private globalsessionhandler: GlobalsessionhandlerService,
    private authorization: AuthorizationService,
    private storage: StorageService,
    private siteminderAuthService: SiteminderAuthService
  ) {}

  ngOnInit(): void {
    try {
      this.routeSurveyId =
        this.route.snapshot.params['id'];

      this.groupId =
        this.route.snapshot.params['groupId'];

      if (
        !(
          this.routeSurveyId === '' ||
          this.routeSurveyId == null
        ) &&
        !(
          this.groupId === '' ||
          this.groupId == null
        )
      ) {
        this.isAnonymousResponse = true;
      }

      this.logoutservice.currentUserLogin.subscribe({
        next: (message) => {
          try {
            this.userLoginStatus = message;
          } catch (error) {
            this.logError(
              'Login status processing failed',
              error
            );
          }
        },
        error: (error) => {
          this.logError(
            'Login status subscription failed',
            error
          );
        },
      });

      this.GetUser();
    } catch (error) {
      this.logError(
        'Logout component initialization failed',
        error
      );
    }
  }

  linkList: Array<
    KeyValue<string, string>
  > = [
    {
      key: 'ValidationSettings',
      value: 'Manage Validations',
    },
    {
      key: 'ManageOrganization',
      value:
        'Manage Organizations & Groups',
    },
    {
      key: 'ManageGroups',
      value: 'Manage Group Users',
    },
    {
      key: 'ManageUser',
      value: 'Manage User Access',
    },
    {
      key: 'SignOut',
      value: 'Sign Out',
    },
  ];

  Action(key: string): void {
    try {
      if (key === 'SignOut') {
        try {
          this.menubarService.updatedDataSelection(
            false
          );
        } catch (error) {
          this.logError(
            'Menu reset failed',
            error
          );
        }

        try {
          this.logoutservice.changeMessage(
            false
          );

          this.logoutservice.setUserLoginStatus(
            false
          );
        } catch (error) {
          this.logError(
            'Login status reset failed',
            error
          );
        }

        try {
          this.siteminderAuthService.logout();
          return;
        } catch (error) {
          this.logError(
            'SiteMinder logout failed',
            error
          );
        }

        try {
          this.sessionHandlerService.clearSession();
        } catch (error) {
          this.logError(
            'Session cleanup failed',
            error
          );
        }

        try {
          this.authService.removeToken();
        } catch (error) {
          this.logError(
            'Token cleanup failed',
            error
          );
        }

        try {
          this.storage.clear();
        } catch (error) {
          this.logError(
            'Storage cleanup failed',
            error
          );
        }

        try {
          this.router.navigate([
            '/login',
          ]);
        } catch (error) {
          this.logError(
            'Login redirect failed',
            error
          );
        }

        return;
      }

      if (
        key ===
        'ManageOrganization'
      ) {
        this.router.navigate([
          '/admin/manageorganizations',
        ]);
      } else if (
        key === 'ManageGroups'
      ) {
        this.router.navigate([
          '/admin/managegroups',
        ]);
      } else if (
        key ===
        'ValidationSettings'
      ) {
        this.router.navigate([
          '/admin/validationsettings',
        ]);
      } else if (
        key === 'ManageUser'
      ) {
        this.router.navigate([
          '/admin/manageusers',
        ]);
      } else if (
        key === 'ManageReport'
      ) {
        this.router.navigate([
          '/admin/managereports',
        ]);
      } else if (
        key === 'UserActivity'
      ) {
        this.router.navigate([
          '/admin/useractivity',
        ]);
      }
    } catch (error) {
      this.logError(
        'Menu action failed',
        error
      );
    }
  }

  GetUser(): void {
    try {
      this.baseHttpService
        .get(
          this.constants.getUser
        )
        .subscribe({
          next: (result) => {
            try {
              if (result != null) {
                this.fullName =
                  result.fullName;

                this.email =
                  result.email;

                this.storage.set(
                  'LoggedInuserId',
                  JSON.stringify(
                    result.customerId
                  )
                );

                this.storage.set(
                  'LoggedInuserMailId',
                  result.email
                );

                this.storage.set(
                  'LoggedInUserTypeId',
                  result.userTypeId
                );

                this.storage.set(
                  'LoggedInUserTypeDesc',
                  result.userTypeDesc
                );

                const loginname =
                  result.fullName.split(
                    ','
                  );

                this.storage.set(
                  'LoggedInuserFirstName',
                  JSON.stringify(
                    loginname[1]
                  )
                );

                const firstletter =
                  loginname[0].substring(
                    0,
                    1
                  );

                const lastletter =
                  loginname[1].substring(
                    1,
                    2
                  );

                this.LoginName =
                  firstletter.toUpperCase() +
                  lastletter.toUpperCase();

                this.userService.getUserDeatils(
                  result
                );

                this.UserRole =
                  result.userTypeId;

                this.userRoleName =
                  result.userTypeDesc;

                this.sessionHandlerService.setLoggedInUserName(
                  loginname[1].trim() +
                    ', ' +
                    loginname[0].trim()
                );

                this.globalsessionhandler.setUserGroupId(
                  result.userGroupId
                );

                this.storage.set(
                  'UserGroupId',
                  result.userGroupId
                );
              }
            } catch (error) {
              this.logError(
                'User data processing failed',
                error
              );
            }
          },
          error: (error) => {
            this.logError(
              'User retrieval failed',
              error
            );
          },
        });
    } catch (error) {
      this.logError(
        'User retrieval setup failed',
        error
      );
    }
  }

  profileCLick(): void {
    try {
      this.profileEnabled =
        !this.profileEnabled;
    } catch (error) {
      this.logError(
        'Profile toggle failed',
        error
      );
    }
  }

  resetPassword(): void {
    try {
      this.menubarService.updatedDataSelection(
        false
      );

      this.sessionHandlerService.clearSession();

      this.authService.removeToken();

      this.logoutservice.changeMessage(
        false
      );

      this.router.navigate([
        '/confirmPassword',
      ]);

      this.storage.remove(
        'CurrentMeuItemUrl'
      );

      this.storage.remove(
        'selectedDashboardGroup'
      );

      this.storage.remove(
        'selectedProcessId'
      );
    } catch (error) {
      this.logError(
        'Password reset navigation failed',
        error
      );
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] = [];

      let currentError: unknown =
        error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof
          Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message === 'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError = null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(
        context
      );
    }
  }
}